import { Injectable, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { IRecentScreen } from 'BI-Libraries/BI-Interfaces/projects/bi-interfaces/src/public-api';

@Injectable({
  providedIn: 'root'
})
export class RecentScreensService {
  private localStorageKey = 'recentPages';
  private maxSavedPages = 10;

  private recentPagesSubject = new BehaviorSubject<IRecentScreen[]>([]);
  public recentPages$ = this.recentPagesSubject.asObservable();

  constructor(
  ) {
    this.recentPagesSubject.next(this.getRecentPagesFlattenedList());
  }

  private getPages(): Map<string, {VisitTime: number, PageName: string}> {
    const storedValue = localStorage.getItem(this.localStorageKey);
    const parsed = storedValue ? JSON.parse(storedValue) : [];
    return new Map<string, IRecentScreen>(parsed);
  }

  private savePages(pages: Map<string, {PageName: string, VisitTime: number}>): void {
    const arrayRepresentation = Array.from(pages.entries());
    localStorage.setItem(this.localStorageKey, JSON.stringify(arrayRepresentation));
  }

  public addPageToRecent(pageUrl: string, pageName:string){
    const pages = this.getPages();
    if (pages.has(pageUrl)) {
      const existing = pages.get(pageUrl)!;
      existing.VisitTime = Date.now();
      pages.delete(pageUrl);
      pages.set(pageUrl, existing);
    } else {
      pages.set(pageUrl, { PageName: pageName, VisitTime: Date.now() });
    }
    // Ensure the map does not exceed the maximum number of pages
    if (pages.size > this.maxSavedPages) {
      const firstKey = pages.keys().next().value;
      pages.delete(firstKey);
    }
    this.savePages(pages);
    this.recentPagesSubject.next(this.getRecentPagesFlattenedList());
  }

  getRecentPagesFlattenedList(): IRecentScreen[] {
    const pages = this.getPages();
    return Array.from(pages.entries()).map(([url, visit]) => ({
      PageUrl: url,
      ...visit,
    }));
  }
}
